import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {Para} from "@irati/ui/src/Labels"

import {Td as TdUi} from "../../../../ui/SimpleTable"

export const Td = styled(TdUi)`
   ${({isFirst}) => (isFirst ? "border-top: none !important;" : "")};
   width: ${({isLeft}) => (isLeft ? "65%" : "35%")};
   padding: 0 !important;
   padding-top: ${padding.small} !important;
   padding-bottom: ${padding.small} !important;
`

export const ParaNoMargin = styled(Para)`
  margin: 0 !important;
`
